var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Notification"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    clipPath: "url(#clip-Notification)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8992",
    "data-name": "Group 8992",
    transform: "translate(-299 -60.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notifications-bell-button",
    transform: "translate(301 61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notifications-none",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M45.9,18a1.805,1.805,0,0,0,1.8-1.8H44.1A1.805,1.805,0,0,0,45.9,18Zm5.85-5.4V7.65a5.791,5.791,0,0,0-4.5-5.67V1.35a1.35,1.35,0,0,0-2.7,0v.63a5.791,5.791,0,0,0-4.5,5.67V12.6l-1.8,1.8v.9h15.3v-.9Zm-1.8.9h-8.1V7.65a4.05,4.05,0,1,1,8.1,0Z",
    transform: "translate(-38.25)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.aa9b8200fababd5174f3b19e189f7984.svg";
export { ForwardRef as ReactComponent };